import React from 'react'

const SettingsContext = React.createContext({})

SettingsContext.displayName = "SettingsContext"

export default SettingsContext

